// Override Settings
var bcSfSearchSettings = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
  label:{
    error:{
      noSuggestionResult: bcSfFilterTranslation.label.search_noSuggestionResult,
      noSuggestionProducts: bcSfFilterTranslation.label.search_noSuggestionProducts,
    },
    suggestion:{
      viewAll: bcSfFilterTranslation.label.search_view_all,
      suggestQuery: bcSfFilterTranslation.label.suggestion_suggestQuery,
      didYouMean: bcSfFilterTranslation.label.suggestion_didYouMean,
    }
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Build Did you mean
BCSfFilter.prototype.buildSuggestionDidYouMean = function(searchTerm, suggestionData, ul) {
    var result = '';
    if (typeof suggestionData !== 'undefined' && Object.keys(suggestionData).length > 0) {
        var suggestQuery = getValueInObjectArray('suggest_query', suggestionData);
        // Get total products
        var totalProduct = getValueInObjectArray('total_product', suggestionData);
        var prevTotalProduct = getValueInObjectArray('prev_total_product', suggestionData);
        if (prevTotalProduct !== '' && totalProduct > 0) totalProduct = prevTotalProduct;
        // Build Did you mean list
        var dymList = getValueInObjectArray('did_you_mean', suggestionData);
        var dym = '';
        if (dymList != '' && dymList.length > 0) {
            for (var k = 0; k < dymList.length; k++) {
                dym += '<a href="' + this.buildSearchLink(dymList[k]) + '">' + dymList[k] + '</a>';
                if (k < dymList.length - 1) dym += '<span>,</span> ';
            }
        }
        // Build content
        if (suggestQuery != searchTerm) {
            if (totalProduct == 0) result += '<p>' + this.getSettingValue('label.error.noSuggestionProducts').replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>') + '</p>';
            if (suggestQuery != '') result += '<p>' + this.getSettingValue('label.suggestion.suggestQuery').replace(/{{ terms }}/g, '<a href="' + this.buildSearchLink(suggestQuery) + '">' + suggestQuery + '</a>') + '</p>';
            if (dym != '') result += '<p>' + this.getSettingValue('label.suggestion.didYouMean').replace(/{{ terms }}/g, dym) + '</p>';
        }
    }
  	
  	return result;
};

// Build No Result of Suggestion
BCSfFilter.prototype.buildSuggestionNoResult = function(searchTerm, data, ul) {
    var content = this.getSettingValue('label.error.noSuggestionResult').replace(/{{ terms }}/g, searchTerm);
  	var result = '<li class="bc-sf-search-suggestion-no-result" aria-label="No Results">';
    result += '<span>' + content + '</span>';
    result += '</li>';
    return result;
};

// Build View All
BCSfFilter.prototype.buildSuggestionViewAll = function(searchTerm, suggestionData, ul) {
    var headerClass = this.class.searchSuggestionHeader;
  	// Build content when total_product > 0
    // If the request is did_you_mean, get the number from suggest_total_product
    var result = '';
  	var totalProduct = getValueInObjectArray('total_product', suggestionData);
    var suggestTotalProduct = getValueInObjectArray('suggest_total_product', suggestionData);
    if (suggestTotalProduct !== '') totalProduct = suggestTotalProduct;
    // Check if total_product > display number of products
    var blocks = this.getSettingValue('search.suggestionBlocks');
    var displayProductNumber = getValueInObjectArray('products', blocks, 'type', 'number');
  	
  
    if (totalProduct > displayProductNumber && totalProduct > 0) {
        result += '<li class="' + headerClass + '-view-all ' + headerClass + '" aria-label="View All">';
        result += '<a href="' + this.buildSearchLink(searchTerm) + '">' + this.getSettingValue('label.suggestion.viewAll').replace(/{{ count }}/g, totalProduct) + '</a>';
        result += '</li>';
    }
  	
    return result;
};

// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm != null) {
        var content = bcSfFilterConfig.label.search_result_number_other;
        if (data.total_product <= 1) {
            var content = bcSfFilterConfig.label.search_result_number_one;
        }
        content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
    }
  	jQ('.' + this.class.searchResultNumber).html(content);
};


/* Start Search Redirect */
function submitSearchFormMobile(t,e){e.preventDefault();var o=bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm);o?window.location.href=o:jQ(t).closest("form").submit()}function beforeSubmitSearchForm(t,e){var o=jQ(t).val(),i=bcsffilter.getSearchRedirectUrl(o);i&&(e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),window.location.href=i)}BCSfFilter.prototype.setSuggestionPosition=function(t){var e=this;if("function"==typeof getSuggestionPosition&&"function"==typeof this.checkIsFullWidthSuggestionMobile){var o=getSuggestionPosition(t),i=this.checkIsFullWidthSuggestionMobile(t)?"top":"top+12";"function"!=typeof e.isSuggestionStyle2||e.isSuggestionStyle2(),"left"==o?jQ(t).autocomplete("option","position",{my:"left "+i,at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right "+i,at:"right bottom",collision:"none"})}else"left"==this.getSettingValue("search.suggestionPosition")?jQ(t).autocomplete("option","position",{my:"left top+12",at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right top+12",at:"right bottom",collision:"none"});if(jQ(t).length>0&&jQ(t).on("keydown",function(o){13==o.keyCode&&e.enterSearchBoxEvent(t,o)}),jQ(t).closest("form").length>0){var n=jQ(t).closest("form").find('[type="submit"]');n&&n.length>0&&n.each(function(e,o){o.setAttribute("onclick","beforeSubmitSearchForm('"+t+"', event)")})}},BCSfFilter.prototype.enterSearchBoxEvent=function(t,e){var o=jQ(t).val(),i=this.getSearchRedirectUrl(o);i&&(e.preventDefault(),window.location.href=i)},BCSfFilter.prototype.getSearchRedirectUrl=function(t){if(this.suggestionCache&&this.suggestionCache.hasOwnProperty(t))for(var e=this.suggestionCache[t],o=0;o<e.length;o++)if("redirect"==e[o].key&&e[o].values){var i=e[o].values;return i=(i=i.replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,"")}return""};
/* End Search Redirect */
